<template>
  <div class="panel-head" style="overflow: hidden">
    <template v-if="!panelHead.isHelpCenter">
      <p v-if="$parent.ticket.status !== 'ASSIGNED'" style="min-height: 54px">
        {{ $parent.widget_settings.translations.general.heading }}
      </p>

      <div
        v-show="
          typeof $parent.widget_settings.team !== 'undefined' &&
          $parent.widget_settings.team.length > 0 &&
          $parent.ticket.status !== 'ASSIGNED'
        "
        class="panel-team"
        :class="{
          'panel-team-mobile': mobile,
          'panel-team-full': typeof $parent.widget_settings.team !== 'undefined' && $parent.widget_settings.team.length === 5
        }"
        role="region"
        aria-label="Support team members"
      >
        <div
          v-for="user in $parent.widget_settings.team"
          :key="user.id || user.first_name"
          role="group"
          :aria-label="`Agent ${user.first_name}`"
          class="panel-team-user"
        >
          <span
            class="panel-team-avatar"
            style="margin-top: 0"
            :style="{ 'background-color': user.image || user.color || color, borderRadius: '18px' }"
            :aria-label="user.image ? '' : `${user.first_name}'s avatar with initial ${user.abbr.substr(0, 1)}`"
          >
            <span v-if="user.image">
              <img :src="user.image" :alt="`Photo of agent, ${user.first_name}`" role="presentation" />
            </span>

            <span v-else aria-hidden="true">
              {{ user.abbr.substr(0, 1) }}
            </span>
          </span>

          <div class="panel-team-agent">{{ user.first_name }}</div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import isMobile from '../Util/IsMobile';

export default {
  name: 'PanelHead',

  props: {
    panelHead: Object,
  },

  data() {
    return {
      mobile: false,
    };
  },

  mounted() {
    this.mobile = isMobile.any();
  },
};
</script>
